import React from 'react';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonText,
} from '@ionic/react';

interface SuccessMessageViewProps {
  message: string;
  onLogin: () => void;
}

const SuccessMessageView: React.FC<SuccessMessageViewProps> = ({ message, onLogin }) => {
  const loginCardStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
    borderRadius: '16px',
  };

  const loginButtonStyle: React.CSSProperties = {
    marginTop: '1.5rem',
    height: '48px',
    fontWeight: 600,
  };

  return (
    <IonCard style={loginCardStyle}>
      <IonCardHeader>
        <IonCardTitle>Success</IonCardTitle>
      </IonCardHeader>
      <IonCardContent>
        <IonText color="medium">
          <p style={{ marginTop: 0, lineHeight: 1.5, textAlign: 'center' }}>{message}</p>
        </IonText>

        <IonButton expand="full" onClick={onLogin} style={loginButtonStyle}>
          Login
        </IonButton>
      </IonCardContent>
    </IonCard>
  );
};

export default SuccessMessageView;
